import { render, staticRenderFns } from "./CollectItems.vue?vue&type=template&id=3e8d9dc8&scoped=true"
import script from "./CollectItems.vue?vue&type=script&lang=js"
export * from "./CollectItems.vue?vue&type=script&lang=js"
import style0 from "./CollectItems.vue?vue&type=style&index=0&id=3e8d9dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d9dc8",
  null
  
)

export default component.exports